import { render } from "./DesignChallenges.vue?vue&type=template&id=5fc8090c&scoped=true"
import script from "./DesignChallenges.vue?vue&type=script&lang=js"
export * from "./DesignChallenges.vue?vue&type=script&lang=js"

import "./DesignChallenges.vue?vue&type=style&index=0&id=5fc8090c&scoped=true&lang=css"

import exportComponent from "/home/runner/work/demo-webapp/demo-webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fc8090c"]])

export default __exports__